import React from 'react';
import PropTypes from 'prop-types';
import Img from 'app/utils/image';
import {
  SPAN_BEHAVIOR_COLORS,
  COLOR_GROUP_ID,
  TECHNOLOGY_GROUP_ID,
  PRODUCT_FEATURES_GROUP_ID,
} from '../facetsListConstants';
import FacetItemWrapper from './facetItemWrapper';

const FacetImageItem = props => {
  const { facet, facetItem } = props;
  const techGroupClass = facet.id === TECHNOLOGY_GROUP_ID ? 'tech-group' : '';
  const isImageCheckbox = !SPAN_BEHAVIOR_COLORS.includes(facetItem.id);
  const checkboxClass = isImageCheckbox ? 'image-color-group' : 'color-group';
  const productFeaturesClass = facet.id === PRODUCT_FEATURES_GROUP_ID ? 'product-features-group' : '';

  // evaluate facet image, use backup color url for color group facet, and an empty value if no image specified
  const colourImage = facet.id === COLOR_GROUP_ID ? `/assets/images/colors/${facetItem.id}.png` : '';
  const facetImage = facetItem.facetImage || colourImage;

  // evaluate checkbox type, use image checkbox if facet image is provided, and use default checkbox otherwise
  const imageCheckbox = facetImage ? (
    <Img
      className={`facet__checkbox image-color-group ${techGroupClass} ${productFeaturesClass}`}
      media={{ url: facetImage }}
      sizes={{ s: '30px' }}
      alt={facetItem.name}
    />
  ) : (
    <span className="facet__checkbox" />
  );
  const checkboxType = isImageCheckbox ? imageCheckbox : <span className="facet__checkbox color-group" />;

  return (
    <FacetItemWrapper checkboxClass={`${checkboxClass} ${techGroupClass} ${productFeaturesClass}`} {...props}>
      {checkboxType}
    </FacetItemWrapper>
  );
};

FacetImageItem.propTypes = {
  facet: PropTypes.shape({ id: PropTypes.string }).isRequired,
  facetItem: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    facetImage: PropTypes.string,
  }).isRequired,
};

export default FacetImageItem;
